import streamImg from "../../../assets/images/stream-img.png";
import userImg from "../../../assets/images/stream-user-img.svg";
import productImg from "../../../assets/images/product-img.png";
import userAvatar from "../../../assets/images/Chat-avatar.png";
import productWatch1 from "../../../assets/images/product-watch.png";
import productWatch2 from "../../../assets/images/product-img.png";
import chatAvatar from "../../../assets/images/Chat-avatar.png";

// Live Stream Dake Data
export const liveStreams = [
    {
        id: 0,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
    {
        id: 1,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
    {
        id: 2,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
    {
        id: 3,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
    {
        id: 4,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
    {
        id: 5,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
    {
        id: 6,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
    {
        id: 7,
        img: streamImg,
        title: "Posuere a nulla ultrice.",
        watch: 4,
        comment: 1,
        date: "1 day ago",
        duration: "1:12:05",
        users: {
            user1: "John Doe",
            user2: "arthur",
            userImg: userImg,
        },
    },
];

// Products fake Data
export const products = [
    {
        id: 0,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
    {
        id: 2,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
    {
        id: 3,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
    {
        id: 4,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
    {
        id: 0,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
    {
        id: 5,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
    {
        id: 6,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
    {
        id: 7,
        productImg: [
            { id: 0, img: productImg },
            {
                id: 1,
                img: "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/Apple_iphone_14_Pro_iPhone_14_Pro_Max_concept_renderings_drdNBC.jpg",
            },
            { id: 2, img: productImg },
            {
                id: 3,
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBVZQg1BTCs8DrssEDpW0D_E_mwkCjfDSTqAMBfwQ5usn0gDS9WfSV6pHOk4ZWLULrtOo&usqp=CAU",
            },
        ],
        title: "G-SHOCK (GBD-200-9)",
        discription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports witt the G-SQUAD line of...",
        price: "75.00",
        discount: "10%off*",
        stock: 2,
        sold: 400,
    },
];

// replayChat page chatList
export const chatList = [
    {
        id: 0,
        avatar: chatAvatar,
        name: "Ashlynn Rosser",
        message: "Hi",
        time: "1 day ago",
    },
    {
        id: 1,
        avatar: chatAvatar,
        name: "Marley Vetrovs",
        message: "How are you?",
        time: "2 day ago",
    },
    {
        id: 2,
        avatar: chatAvatar,
        name: "Skylar Westervelt",
        message: "Hi",
        time: "3 day ago",
    },
    {
        id: 3,
        avatar: chatAvatar,
        name: "Ashlynn Rosser",
        message: "Hello",
        time: "5 day ago",
    },
    {
        id: 4,
        avatar: chatAvatar,
        name: "Erin Geidt",
        message: "Hi",
        time: "10 day ago",
    },
    {
        id: 5,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 6,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 7,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 8,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 9,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 10,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 11,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 12,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 13,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
    {
        id: 14,
        avatar: chatAvatar,
        name: "Craig Dorwart",
        message: "How are you?",
        time: "5 day ago",
    },
];

// replayChat page product
export const replayProducts = [
    {
        id: 0,
        userName: "Ronald Richards",
        userMessage: "Hi",
        userImg: userAvatar,
        productImg: [
            {
                original: productWatch1,
                thumbnail: productWatch1,
            },
            {
                original: productWatch2,
                thumbnail: productWatch2,
            },
            {
                original: productWatch1,
                thumbnail: productWatch1,
            },
            {
                original: productWatch2,
                thumbnail: productWatch2,
            },
        ],
        productName: "G-SHOCK (GBD-200-9)",
        productPrice: "750",
        productQuantitiy: 2,
        productDiscription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports with the G-SQUAD line",
    },
    {
        id: 0,
        userName: "Ronald Richards",
        userMessage: "Hi",
        userImg: userAvatar,
        productImg: [
            {
                original: productWatch1,
                thumbnail: productWatch1,
            },
            {
                original: productWatch2,
                thumbnail: productWatch2,
            },
            {
                original: productWatch1,
                thumbnail: productWatch1,
            },
            {
                original: productWatch2,
                thumbnail: productWatch2,
            },
        ],
        productName: "G-SHOCK (GBD-200-9)",
        productPrice: "750",
        productQuantitiy: 2,
        productDiscription:
            "G-SQUAD GBD-200 SERIES Say hello to some serious passion for sports with the G-SQUAD line",
    },
];
